import React from 'react';

export const Cosult_Text = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    renderContent: () => <span>CONTACT</span>,
  },
];

export const Create_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    renderContent: () => <span>COLLABORATE</span>,
  },
];

export const Join_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    renderContent: () => <span>JOIN THE TEAM</span>,
  },
];

export const Practice_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    renderContent: () => <span>INTERNSHIPS / COMMUNITY SERVICE</span>,
  },
];
